import {Fragment, useEffect, useState} from "react";
import { IPageData } from "../../interfaces/page";
import { usePageData } from '../../hooks/usePage';
import { useParams } from "react-router-dom";
import { message } from "antd";
import Loading from "../../components/Loading";
import PublicLayout from "../../layout/public/Public";
import moment from "moment";
import "../styles/formulario.css";

const pageData: IPageData = {
  fulFilled: true,
  title: 'Pago de Servicio',
  breadcrumbs: [
    // {
    //   title: 'Home',
    //   route: 'pago'
    // },
    {
      title: 'Pago de Servicio',
    }
  ]
};

const FormularioPagoNiubiz = () => {
  usePageData(pageData);
  const [loading, setLoading] = useState(true)
  const [factura, setFactura] = useState({
    ap_nom:'',
    medico:'',
    id_tipdoc: '',
    nume_doc:'',
    Parv_Descripcion:'',
    fecha_atencion:'',
    Email: '',
    Monto_Paciente: null
  })

  /**************EL ID_FACTU DE LA URL******************** */
  const {id_factu}: {id_factu: string} = useParams();

  useEffect(() => {
    getTicketById(id_factu)
  }, []);


  const getTicketById = async(id_factu) => {
    try {
      await fetch(`${process.env.REACT_APP_HOSTNAME}/getTicketById/${id_factu}`)
      .then(res => res.json())
      .then(data => {
        // console.log(data)
        if (data.message) {
          message.error('El ticket Solicitado ya se ha Pagado')
          const interval = setInterval(() => { 
            window.location.href='https://limatambo.com.pe/'
          }, 3000);
          return () => clearInterval(interval);
        }else {
          setFactura(data)
          GetSesionToken(data)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const GenerarJson = async(venta: any) => {
    const body = {
      channel: "web",
      amount: venta.Monto_Paciente,//10.5,
      antifraud: {
          clientIp: "",
          merchantDefineData: {
          MDD4: venta.Email,//"integraciones@niubiz.com.pe",
          MDD32: venta.nume_doc,//"71744016",
          MDD75: "Invitado",
          MDD77: 1
          }
      },
      dataMap: {
          cardholderCity: "Cajamarca",
          cardholderCountry: "PE",
          cardholderAddress: "Jr. Puno 265",
          cardholderPostalCode: "06000",
          cardholderState: "CAJ",
          cardholderPhoneNumber: venta.celular//"986354805"
      }
    }

    return (body)
  }

  const  GetSesionToken = async(venta: any) => {
    const bodyJSON = await GenerarJson(venta)
    try {
      await fetch(`${process.env.REACT_APP_HOSTNAME}/GetSessionToken`, {
        method: "POST",
        body: JSON.stringify(bodyJSON),
        headers:{
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        }
      }).then(res => res.json())
      .then(data => {
        setLoading(false)
        // console.log(data)
        if (data.status === 200) {
          // setsessionKey(data.sessionKey)
          CargarFormulario(data.sessionKey, venta)
        }
      }).catch(err => console.log(err));
    } catch (error) {
      console.log(error)
    }
  }

  const CargarFormulario = async(sessionKey: string, venta: any) => {
 
    // para que el formulario no se redireccione al pagar
    if (document.getElementById("formulario-pasarela")) {
      document.getElementById("formulario-pasarela").addEventListener("submit", function (event) {
        event.preventDefault(); 
      });
    }
    const existingScript = document.getElementById("checkout-script");
    if (existingScript) {
      existingScript.remove();
    }

    // Crear un nuevo script
    const script = document.createElement("script");
    script.src = "https://static-content.vnforapps.com/v2/js/checkout.js";
    script.type = "text/javascript";
    script.id = "checkout-script";
    
    // Definir los atributos del script (parámetros de la pasarela)
    script.setAttribute("data-sessiontoken", sessionKey);
    script.setAttribute("data-channel", "web");
    script.setAttribute("data-merchantid", "651030725");
    script.setAttribute("data-purchasenumber", (parseInt(venta.id_factu)).toString()/*"prueba12"*/);
    script.setAttribute("data-amount", (venta.Monto_Paciente).toString()/*"10.5"*/);
    script.setAttribute("data-expirationminutes", "20");
    script.setAttribute("data-timeouturl", `https://pacientes.limatambo.com.pe/doctors`);
    script.setAttribute("data-merchantlogo", `${window.origin}/content/imgFormPasarela.jpeg`);
    script.setAttribute("data-formbuttoncolor", "#000000");
    
    script.onload = () => {
      window.addEventListener("message", async (event) => {
        // console.log("Evento recibido:", event);
    
        // Verifica que el evento provenga de la pasarela de pago
        if (event.origin !== "https://static-content.vnforapps.com") {
          console.error("Evento recibido de un origen no permitido:", event.origin);
          return;
        }
    
        try {
          // Parsea el string JSON a un objeto
          const eventData = JSON.parse(event.data);
    
          // Verifica si el método es "complete" y contiene el token
          if (eventData.method === "complete" && eventData.args[0]?.token) {
            const { token, email, channel } = eventData.args[0];
            // console.log("Pago exitoso - Token:", token);
            const transaccion = eventData.args[0]
            // Envía los datos al backend para autorizar la transacción
            const response = await fetch(`${process.env.REACT_APP_HOSTNAME}/AuthorizationTransaction`, {
              method: "POST",
              body: JSON.stringify({
                transaccion: transaccion,
                venta
              }),
              headers: {
                "Content-Type": "application/json",
              },
            });
    
            if (!response.ok) {
              throw new Error("Error al autorizar la transacción");
            }

            if (response.status === 200) {
              console.log("Transacción autorizada correctamente con status:", response.status);
          
              // Redirección solo si el status es 200
              window.location.href = `https://pacientes.limatambo.com.pe/cita/CitaAutorizada/${id_factu}`;
            }
    
            console.log("Transacción autorizada correctamente");
    
          } else {
            console.error("El evento no contiene el token esperado:", eventData);
          }
        } catch (error) {
          console.error("Error al procesar el evento:", error);
          message.error("Hubo un error al procesar el pago. Por favor, inténtalo de nuevo.");
        }
      });
    };
  
    // Agregar el script al formulario
    document.getElementById("formulario-pasarela").appendChild(script);
    
  }
  
  if (loading == true) {
    return(
      <PublicLayout bgImg={`${window.origin}/content/imgFormPasarela.jpeg`}>
        <Loading/>
      </PublicLayout>
    )
  } else {
    return(
      <PublicLayout bgImg={`${window.origin}/content/imgFormPasarela.jpeg`}>
        <div style={{display:"flex", justifyContent:"center"}}>
          <label style={{fontSize:'20px', fontWeight:'bold', textDecorationLine: 'underline'}}>
            Formulario de Pago Virtual 
          </label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Servicio:</label>  
          <label className="label-datos-muestra-form">{factura.Parv_Descripcion}</label>
        </div>
        
        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Paciente:</label>
          <label className="label-datos-muestra-form">{factura.ap_nom}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Correo:</label>
          <label className="label-datos-muestra-form">{factura.Email}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Dr(a).:</label>
          <label className="label-datos-muestra-form">{factura.medico}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Fecha de atención:</label>
          <label className="label-datos-muestra-form">{moment.utc(factura.fecha_atencion).format('DD/MM/YYYY')}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Orden N°:</label>
          <label className="label-datos-muestra-form">{factura.nume_doc}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Total a Pagar:</label>
          <label className="label-datos-muestra-form">{factura.Monto_Paciente}</label>
        </div>

        <div style={{display:"flex", justifyContent:"center"}}>
          <form
            action={`https://pacientes.limatambo.com.pe/cita/CitaAutorizada/${id_factu}`}
            method="post" 
            id="formulario-pasarela">
          </form>
        </div>
        
      </PublicLayout>
    )
  }
  
}

export default FormularioPagoNiubiz